import React from 'react';

import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';

import { makeStyles, withStyles } from 'tss-react/mui';

const RawAccordionSummary = withStyles(AccordionSummary, {
  root: {
    padding: 0,
    minHeight: 0,
  },
  content: {
    margin: 0,
  },
  expanded: {
    display: 'none',
  }
});


const RawAccordionDetails = withStyles(AccordionDetails, {
  root: {
    padding: 0,
  },
});


const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(3),
  },
  iconSpacer: {
    paddingLeft: '58px',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  accordion: {
    flex: 1,
  },
}));


export type ExpandableSectionProps = {
  isExpanded: boolean;
  testId?: string;
};


export const ExpandableSection: React.FC<ExpandableSectionProps> = (props) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root} data-testid={props.testId ?? 'expandable-section'}>
      <Box className={classes.accordion}>
        <Accordion
          elevation={0}
          expanded={props.isExpanded}
          slotProps={{
            transition: { unmountOnExit: true } // important
          }}
        >
          <RawAccordionSummary />
          <RawAccordionDetails>
            {props.children}
          </RawAccordionDetails>
        </Accordion>
      </Box>
    </Box>
  );
};
